module.exports = __webpack_public_path__ + "img/exclusive.06b0ec1e.svg";